import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstant } from '@app/core/constant/app-constant';

@Component({
  selector: 'app-careers',
  template:
    '<p class="text-center" style="margin-top: 100px;"> You are being redirected to the careers page.  If you are not redirected, please click <a href="https://corp.abctalkies.in/careers" target="_blank">here</a>.</p>',
})
export class CareersComponent implements OnInit {
  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    window.location.href = AppConstant.StaticUrl.careersUrl;
  }
}
